////////////////////////////////////////////
// SOLANA WALLET PROVIDER — @solana/wallet-adapter-react
////////////////////////////////////////////
//
// WALLETS ARE DISCOVERED VIA THE WALLET-STANDARD (PHANTOM / SOLFLARE /
// BACKPACK ALL SELF-REGISTER), SO THE EXPLICIT ADAPTER LIST IS EMPTY.
// autoConnect REPLICATES THE VANILLA APP'S STICKY SILENT RECONNECT.
// THERE IS NO ConnectionProvider ON PURPOSE: THE CLIENT NEVER SPEAKS SOLANA
// RPC — THE SERVER BUILDS AND SUBMITS EVERY TRANSACTION (/api/tx/*).
import { useMemo, type ReactNode } from "react";
import { WalletProvider } from "@solana/wallet-adapter-react";

export function SolanaProvider({ children }: { children: ReactNode }) {

  // EMPTY LIST — WALLET-STANDARD WALLETS SELF-REGISTER AT RUNTIME
  const wallets = useMemo(() => [], []);

  return (
    <WalletProvider wallets={wallets} autoConnect>
      {children}
    </WalletProvider>
  );
}
